/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../__generated__/zeus/types';

import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type NavSellerTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type NavSellerTransactionsQuery = { customerAccount: { seller: { transactions: Array<
        | { __typename: 'ClosedTransaction', id: Types.Scalars['ID']['output'], address: { id: Types.Scalars['ID']['output'], street: Types.Scalars['String']['output'] } }
        | { __typename: 'DeniedTransaction', id: Types.Scalars['ID']['output'], address: { id: Types.Scalars['ID']['output'], street: Types.Scalars['String']['output'] } }
        | { __typename: 'InContractTransaction', id: Types.Scalars['ID']['output'], address: { id: Types.Scalars['ID']['output'], street: Types.Scalars['String']['output'] } }
        | { __typename: 'InitializingTransaction', id: Types.Scalars['ID']['output'], address: { id: Types.Scalars['ID']['output'], street: Types.Scalars['String']['output'] } }
        | { __typename: 'PreContractTransaction', id: Types.Scalars['ID']['output'], address: { id: Types.Scalars['ID']['output'], street: Types.Scalars['String']['output'] } }
        | { __typename: 'WithdrawnTransaction', id: Types.Scalars['ID']['output'], address: { id: Types.Scalars['ID']['output'], street: Types.Scalars['String']['output'] } }
      > } } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const NavSellerTransactionsDocument = /*#__PURE__*/ new TypedDocumentString(`
    query NavSellerTransactions {
  customerAccount {
    seller {
      transactions(first: 5) {
        __typename
        id
        address {
          id
          street
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<NavSellerTransactionsQuery, NavSellerTransactionsQueryVariables>;